<template>
  <BaseFrame
    :cancelText="isEdit ? '取消' : ''"
    clearText=""
    idText="订单编码"
    :id="code"
    :infosArr="infos"
    :subInfosArr="subInfosArr"
    :submitText="isEdit ? '提交' : ''"
    @submit='submit'
  >
    <div class="container" slot="content">
      <lk-card>
        <PharmaceuticalCareButton :showPharmaceuticalCareButton="true"></PharmaceuticalCareButton>
        <lk-row style="margin-bottom: 10px;">
          <lk-col span="24" class="prescriptionCol">
            <lk-tabs  value="name1" :animated='true'>
             <lk-tab-pane label="药学服务信息" name="name1"  v-if='!isCheck'>
                <PharmaceuticalCareInfo
                  v-model="careInfo"
                  :diseaseList="diseaseList"
                  :isEdit="isEdit"
                  :sourceType="sourceType"
                  ref="careInfo"
                ></PharmaceuticalCareInfo>
              </lk-tab-pane>
              <lk-tab-pane label="用药指导和随访预约" name="name2"  v-if='!isCheck'>
                <GuidanceAndAppointment
                  v-model="interviewTask"
                  ref="guidanceAndAppointment"
                  :salePrescription="careInfo.salePrescription"
                  :saleOrderDetail="saleOrderDetail"
                  :historyPurchaseDetails="historyPurchaseDetails"
                  :taskIds="taskIds"
                  :checked.sync="checked"
                  :interviewVoList="interviewVoList"
                  :isEdit="isEdit"
                ></GuidanceAndAppointment>
              </lk-tab-pane>
              <lk-tab-pane label="患者用药咨询" name="name3"  v-if='!isCheck'>
                <MedicationConsultation
                v-model="orderGoodsInquirys"
                :medicationConsultation="saleOrderDetail"
                :isEdit="isEdit"
                ></MedicationConsultation>
              </lk-tab-pane>
            </lk-tabs>
          </lk-col>
        </lk-row>
      </lk-card>
    </div>
  </BaseFrame>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import sale from '../../services/sale';
import utils from '../../libs/utils';
import GuidanceAndAppointment from './GuidanceAndAppointment.vue';
import MedicationConsultation from '../../components/sale/MedicationConsultation.vue';
import PharmaceuticalCareInfo from '../../components/prescription/CareInfo.vue';
import PharmaceuticalCareButton from '../../components/sale/PharmaceuticalCareButton.vue';


export default {
  name: 'pharmaceuticalCare',
  components: {
    BaseFrame,
    GuidanceAndAppointment,
    MedicationConsultation,
    PharmaceuticalCareInfo,
    PharmaceuticalCareButton,
  },

  computed: {
  },
  watch: {

  },
  data() {
    return {
      checked: false, // 确认发药
      sourceType: '', // 来源
      diseaseList: [], // 处方诊断选项
      careInfo: {
        salePrescription: {}, // 处方信息
        diseaseQo: {}, // 患者疾病信息
        saleUsageList: [], // 药品信息
      },
      saleOrderDetail: [], // 购药信息
      interviewTask: {},
      historyPurchaseDetails: [], // 历史购药信息
      taskIds: [], // 任务编号
      interviewVoList: [], // 随访记录
      isEdit: false,
      orderGoodsInquirys: [],

      infos: [],
      subInfosArr: [],
      resData: {}, // detail接口返回的数据
      inquiryList: [], // 患者用药咨询
      isCheck: false, // 是否是点击查看进入
      medicationConsultation: [],
      code: '',
      addGoods: false,
    };
  },
  methods: {
    async submit() {
      const careInfoValid = await this.$refs.careInfo.validateForm().then(valid => valid);
      if (!careInfoValid) {
        this.$Message.error('请完善「药学服务信息」');
        return;
      }
      const namelist = [];
      this.careInfo.saleUsageList.forEach((item) => {
        if (!item.goodsUsageType || !item.frequency || !item.goodsDosage) {
          namelist.push(item.approvedName || item.approvedDrugNames);
        }
      });
      if (namelist.length) {
        this.$Message.error(`请在${namelist.join('、')}的商品行填写用法，频次和每次用量`);
        return;
      }
      const gAValid = await this.$refs.guidanceAndAppointment.validate().then(valid => valid);
      if (!gAValid) {
        return;
      }
      if (!this.checked) {
        this.$Message.error('请确认发药');
        return;
      }
      const {
        salePrescription,
        diseaseQo,
        saleUsageList,
      } = this.careInfo;
      const params = {
        orderId: this.$route.params.id,
        interview: { ...this.interviewTask },
        inquiryList: this.orderGoodsInquirys,
        salePrescription,
        diseaseQo,
        saleUsageList,
      };
      sale.savePharmaceuticalCareInfo(params).then((res) => {
        if (res.data.status === 200) {
          this.$router.go(-1);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPharmaceuticalCareDetail() {
      const params = {
        taskId: this.$route.params.taskId || '',
        orderId: this.$route.params.id || '',
      };
      sale.getPharmaceuticalCareInfoDetail(params).then((res) => {
        if (res.data.status === 200) {
          const {
            saleOrderDetail,
            historyPurchaseVo,
            interview,
            interviewVoList,
            taskIds,
            salePrescription,
            orderGoodsInquirys,
            disease,
          } = res.data.data;
          this.saleOrderDetail = saleOrderDetail;
          this.historyPurchaseDetails = historyPurchaseVo;
          this.interviewVoList = interviewVoList;
          this.taskIds = taskIds;
          const prescription = utils.deepClone(salePrescription);
          if (prescription.picUrls && prescription.picUrls.length > 0) {
            const {
              picUrls,
            } = prescription;
            prescription.picUrl = picUrls[0];
          }
          this.salePrescription = prescription;
          this.interviewTask = interview || salePrescription;
          this.careInfo.salePrescription = salePrescription;
          this.careInfo.saleUsageList = saleOrderDetail;
          this.careInfo.diseaseQo = disease || {};

          const { provinceId, cityId, countyId } = salePrescription;
          this.careInfo.salePrescription.locationArr = [
            provinceId, cityId, countyId,
          ];
          const { provinceName, cityName, countyName } = salePrescription;
          this.careInfo.salePrescription.locationString = countyName ? `${provinceName}/${cityName}/${countyName}` : '';
          this.orderGoodsInquirys = orderGoodsInquirys || [];
          // 待办事项不能判断是不是本药师，所以只能跳转编辑页面，前端判断一下能否查看
          if (this.$route.name === 'pcOrderPharmaceuticalCare' || this.$route.name === 'pharmaceuticalCare') {
            this.isEdit = salePrescription.pharmaceuticalCareOnlyCheck === 2;
          }
          this.sourceType = salePrescription.epSourceType;
          this.code = salePrescription.orderNo;
          this.infos = [{
            name: '营业员:',
            value: salePrescription.createUserName,
          },
          {
            name: '创建时间:',
            value: utils.exchangeTimeToSecond(salePrescription.createTime),
          },
          {
            name: '订单来源:',
            value: salePrescription.epSourceTypeName,
          },
          ];
          this.subInfosArr = [
            {
              name: '日报编号',
              value: salePrescription.proceedsCode || '',
            },
          ];
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getDiseaseList() {
      return new Promise((resolve) => {
        sale.getDiseaseInfo().then((res) => {
          if (res.data.status === 200) {
            this.diseaseList = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
  },
  created() {

  },
  mounted() {
    this.isEdit = !(this.$route.name === 'pcOrderPharmaceuticalCareCheck');
    Promise.all([
      this.getDiseaseList(),
    ]).then(() => {
      this.getPharmaceuticalCareDetail();
    });
  },
};

</script>
<style lang="less" scoped>

</style>
